import { IPrivilegeAttribute } from '../interfaces/client-vars.interface';
import { IPrivilegeManager } from '../interfaces/privilege-manager.interface';
import { SlideDataServices } from '../slide-data-services.core';
import { OnlineEditServices } from '../../scenes/online/core/online-edit-services.core';
import { EditEvents, IEditEvents } from '../interfaces/event.interface';
import { isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';

export class PrivilegeManager implements IPrivilegeManager {
    private privilegeAttribute: IPrivilegeAttribute;
    #editable = false;
    public constructor(private editEvent: IEditEvents) {
        this.init();
    }

    public getPrivilegeAttribute() {
        return this.privilegeAttribute;
    }

    public get readable() {
        return !!this.privilegeAttribute.can_read;
    }

    public get editable() {
        return this.#editable;
    }

    public get copyable() {
        return !!this.privilegeAttribute.can_copy;
    }

    public get exportable() {
        return !!this.privilegeAttribute.can_export;
    }

    public get printable() {
        return !!this.privilegeAttribute.can_print;
    }

    public get canApplyEdit() {
        return !!this.privilegeAttribute.can_apply_edit;
    }

    public get canGenerateCopies() {
        return !!this.privilegeAttribute.can_copy_doc;
    }

    public changeEditable(editable: boolean) {
        if (this.#editable === editable) return;
        this.#editable = editable;
        if (!editable) {
            this.editEvent.emit(EditEvents.SetDocCopyable);
        }
    }

    private async init() {
        const clientVarsService = await SlideDataServices.ClientVarsService.promise();
        this.privilegeAttribute = clientVarsService.getClientVars().privilegeAttribute ?? {};
        this.changeEditable(!!this.getPrivilegeAttribute().can_edit && !isPreview());

        const otTransform = await OnlineEditServices.OTTransformManager.promise();
        this.changeEditable(this.#editable && otTransform.supported);
    }
}
